import * as React from "react";
const SvgFiRrRent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-rent_svg__a)">
      <path
        fill="#062147"
        d="m22.828 9.914-3.401-3.401C18.939 2.83 15.759 0 12 0 8.77 0 5.985 2.039 4.943 5.028q-.312.03-.623.096C2.184 5.571.484 7.323.092 9.482-.271 11.49.455 13.448 2 14.715v.284c0 .266.105.52.293.707l.793.793-.793.793a1 1 0 0 0 0 1.414l.793.793-.793.793a1 1 0 0 0 0 1.414l1.648 1.647c.43.43.994.646 1.56.646.564 0 1.13-.216 1.56-.646l1.061-1.062c.566-.566.879-1.32.879-2.121v-5.431a5.49 5.49 0 0 0 2-4.241 5.48 5.48 0 0 0-2.034-4.271 5.5 5.5 0 0 0-1.963-1.011 5.47 5.47 0 0 1 4.998-3.217c2.72 0 5.009 2.025 5.414 4.672l-3.242 3.242a4.02 4.02 0 0 0-1.172 2.828v7.258c0 2.206 1.794 4 4 4h3c2.206 0 4-1.794 4-4v-7.258a4.02 4.02 0 0 0-1.172-2.828zM9 10.5a3.5 3.5 0 0 1-1.557 2.909A1 1 0 0 0 7 14.24v5.932c0 .263-.106.521-.293.707l-1.061 1.062c-.068.068-.223.068-.291 0l-.941-.94.793-.793a1 1 0 0 0 0-1.414l-.793-.793.793-.793a1 1 0 0 0 0-1.414L4 14.587v-.372a1 1 0 0 0-.442-.83 3.47 3.47 0 0 1-1.497-3.544c.248-1.367 1.321-2.477 2.67-2.759 1.088-.227 2.14.022 2.975.7a3.49 3.49 0 0 1 1.295 2.719zM22 20c0 1.103-.897 2-2 2h-3c-1.103 0-2-.897-2-2v-7.258c0-.526.214-1.042.586-1.414L18.5 8.414l2.914 2.914c.372.372.586.888.586 1.414zM5.5 8a1.5 1.5 0 1 1-.001 3.001A1.5 1.5 0 0 1 5.5 8"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-rent_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrRent;
